import { render, staticRenderFns } from "./PromotionsDashboardV2.vue?vue&type=template&id=0f9b3bea"
import script from "./PromotionsDashboardV2.vue?vue&type=script&lang=js"
export * from "./PromotionsDashboardV2.vue?vue&type=script&lang=js"
import style0 from "./PromotionsDashboardV2.vue?vue&type=style&index=0&id=0f9b3bea&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports